import { useTranslation } from 'react-i18next';

import { useConditionPdf } from '~/api/conditions';
import { Card, Dialog, PdfPreview, Spinner } from '~/components';

import { pdfDialogStyle } from './ConditionPdfDialog.css';

type Props = {
  conditionId: number;
};

export const ConditionPdfDialog = ({ conditionId }: Props) => {
  const { data: conditionPdf, isError, refetch } = useConditionPdf(conditionId);

  const { t } = useTranslation(['common', 'invoices']);
  const title = t('invoices:conditionDialog.title');

  return (
    <Dialog.Body className={pdfDialogStyle}>
      <Dialog.Header title={title} />

      {isError ? (
        <Card.Error onRetry={() => refetch()} title={t('common:error')} />
      ) : conditionPdf ? (
        <PdfPreview showToolbar={false} src={`data:application/pdf;base64,${conditionPdf}`} title={title} />
      ) : (
        <Spinner aria-label={t('common:loading')} size={32} />
      )}
    </Dialog.Body>
  );
};
